import { environment } from './../../environments/environment';
import { NgModule } from '@angular/core';
import { AuthModule } from 'angular-auth-oidc-client';


@NgModule({
    imports: [AuthModule.forRoot({
        config: {
            authority: environment.identityUrl,
            redirectUrl: window.location.origin,
            postLogoutRedirectUri: window.location.origin,
            clientId: 'login-client',
            scope: 'openid profile offline_access users-scope',
            responseType: 'code',
            silentRenew: true,
            useRefreshToken: true,
            silentRenewUrl: window.location.origin + '/silent-renew.html',
            renewTimeBeforeTokenExpiresInSeconds: 10
        }
      })],
    exports: [AuthModule],
})
export class AuthConfigModule {}
